import Head from 'expo-router/head';

/**
 * Loads Google Sans + Material Symbols Outlined fonts for the web build.
 * Required by the Gemini-style design system: Material Symbols are the only
 * permitted icon set, and Google Sans is the body font family.
 */
export function WebFontLinks() {
  return (
    <Head>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Google+Sans:wght@400;500;600;700&family=Google+Sans+Text:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
      {/* `display=block` matters more here than for a text font. Material
          Symbols renders each icon as a ligature over its literal name, so with
          the default `swap` behaviour every icon in the app paints as the word
          "chevron_right" or "progress_activity" until the font arrives - and
          stays that way permanently if it never does. `block` renders nothing
          during the swap period instead, which is the right trade for a glyph
          that carries no meaning as text. */}
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,300..600,0..1,-50..200&display=block"
        rel="stylesheet"
      />
    </Head>
  );
}
